import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminPrescriptionsPage } from './admin-prescriptions';
import { DirectivesModule } from '../../directives/directives.module';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  declarations: [
    AdminPrescriptionsPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminPrescriptionsPage),
    DirectivesModule,
    AgGridModule.withComponents([])
  ],
})
export class AdminPrescriptionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-prescriptions/admin-prescriptions.module.ts